<template>
    <div>
        <kgr-form-row
            :label="$t('Gültig ab')"
            field-name="start"
            :error="error"
            required
            inline
        >
            <kgr-date-picker v-model.trim="childParentIncome.start" />
        </kgr-form-row>

        <div class="kgr-inputGroup">
            <div class="kgr-inputGroup__label">
                {{ $t('Höchstsatz') }}
            </div>
            <kgr-child-parent-income-highest-rate
                v-model="childParentIncome.highestRate"
                @expand="isExpanded = $event"
            />
        </div>

        <table
            v-if="isExpanded"
            class="kgr-table kgr-table--block kgr-table--bordered kgr-row"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline alignRight">
                        {{ $t('Bruttobeträge für') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Eltern 1') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Eltern 2') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="kgr-table__row">
                    <td
                        colspan="3"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Einkommensbestandteile') }}
                    </td>
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Einkommensteuerbescheid') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeTaxAssessment"
                        field="parentIncome1.incomeTaxAssessment"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeTaxAssessment"
                        field="parentIncome2.incomeTaxAssessment"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Jahresbruttoeinkommen (elek. Lohnsteuerbescheinigung)') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.grossAnnualIncome"
                        field="parentIncome1.grossAnnualIncome"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.grossAnnualIncome"
                        field="parentIncome2.grossAnnualIncome"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Einkünfte aus Land-, Forstwirtschaft sowie Gewerbebetrieb') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeAgricultureForestryAndCommercial"
                        field="parentIncome1.incomeAgricultureForestryAndCommercial"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeAgricultureForestryAndCommercial"
                        field="parentIncome2.incomeAgricultureForestryAndCommercial"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Einkünfte aus Kapitalvermögen (Zinsen, Dividende etc.)') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeCapitalAssets"
                        field="parentIncome1.incomeCapitalAssets"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeCapitalAssets"
                        field="parentIncome2.incomeCapitalAssets"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Einkünfte aus Vermietung und Verpachtung') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeRentalAndLeasing"
                        field="parentIncome1.incomeRentalAndLeasing"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeRentalAndLeasing"
                        field="parentIncome2.incomeRentalAndLeasing"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('wegen Geringfügigkeit pauschal versteuerte Einkommen') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeTaxedDueToInsignificance"
                        field="parentIncome1.incomeTaxedDueToInsignificance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeTaxedDueToInsignificance"
                        field="parentIncome2.incomeTaxedDueToInsignificance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Renten') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.pensions"
                        field="parentIncome1.pensions"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.pensions"
                        field="parentIncome2.pensions"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Unterhaltsleistungen für die Personensorgeberechtigten') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.maintenanceServicesForCustodians"
                        field="parentIncome1.maintenanceServicesForCustodians"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.maintenanceServicesForCustodians"
                        field="parentIncome2.maintenanceServicesForCustodians"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Kindesunterhalt bzw. Unterhaltsvorschuss') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.childSupport"
                        field="parentIncome1.childSupport"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.childSupport"
                        field="parentIncome2.childSupport"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Sonstiges') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeOthers"
                        field="parentIncome1.incomeOthers"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeOthers"
                        field="parentIncome2.incomeOthers"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>

                <tr class="kgr-table__row">
                    <td
                        colspan="3"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Einnahmen nach dem SGB III Arbeitsförderung und nach dem SGB II Grundsicherung') }}
                    </td>
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Arbeitslosengeld') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.unemploymentBenefit"
                        field="parentIncome1.unemploymentBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.unemploymentBenefit"
                        field="parentIncome2.unemploymentBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('ALG II') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.alg2"
                        field="parentIncome1.alg2"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.alg2"
                        field="parentIncome2.alg2"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('BAföG') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.bafoeg"
                        field="parentIncome1.bafoeg"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.bafoeg"
                        field="parentIncome2.bafoeg"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Asylbewerberleistungen (AsylbLG)') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.asylumSeekerBenefits"
                        field="parentIncome1.asylumSeekerBenefits"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.asylumSeekerBenefits"
                        field="parentIncome2.asylumSeekerBenefits"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Sonstiges') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeOthersSgb"
                        field="parentIncome1.asylumSeekerBincomeOthersSgbenefits"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeOthersSgb"
                        field="parentIncome2.incomeOthersSgb"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>

                <tr class="kgr-table__row">
                    <td
                        colspan="3"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Sonstige Leistungen nach anderen Sozialgesetzen') }}
                    </td>
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('§ 32b EstG') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.benefitsParagraph32bEstG"
                        field="parentIncome1.benefitsParagraph32bEstG"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.benefitsParagraph32bEstG"
                        field="parentIncome2.benefitsParagraph32bEstG"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Wohngeld') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.housingBenefit"
                        field="parentIncome1.housingBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.housingBenefit"
                        field="parentIncome2.housingBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Krankengeld') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.sicknessBenefit"
                        field="parentIncome1.sicknessBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.sicknessBenefit"
                        field="parentIncome2.sicknessBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Mutterschaftsgeld') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.maternityBenefit"
                        field="parentIncome1.maternityBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.maternityBenefit"
                        field="parentIncome2.maternityBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Elterngeld') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.parentalBenefit"
                        field="parentIncome1.parentalBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.parentalBenefit"
                        field="parentIncome2.parentalBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Kindergeld') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.childBenefit"
                        field="parentIncome1.childBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.childBenefit"
                        field="parentIncome2.childBenefit"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Sonstiges') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.otherServicesDueToSocialLaws"
                        field="parentIncome1.otherServicesDueToSocialLaws"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.otherServicesDueToSocialLaws"
                        field="parentIncome2.otherServicesDueToSocialLaws"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>

                <tr class="kgr-table__row">
                    <td
                        colspan="3"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Einkommen aus selbständiger Arbeit') }}
                    </td>
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Geschätztes Einkommen') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeFromSelfEmploymentEstimated"
                        field="parentIncome1.incomeFromSelfEmploymentEstimated"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeFromSelfEmploymentEstimated"
                        field="parentIncome2.incomeFromSelfEmploymentEstimated"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Einkommen laut Steuerbescheid') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeFromSelfEmploymentAccordingToTaxAssessment"
                        field="parentIncome1.incomeFromSelfEmploymentAccordingToTaxAssessment"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeFromSelfEmploymentAccordingToTaxAssessment"
                        field="parentIncome2.incomeFromSelfEmploymentAccordingToTaxAssessment"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>

                <tr class="kgr-table__row">
                    <td
                        colspan="3"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Einkommensminderung') }}
                    </td>
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Unterhaltszahlungen') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByAlimonyPayments"
                        field="parentIncome1.incomeDecreaseByAlimonyPayments"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByAlimonyPayments"
                        field="parentIncome2.incomeDecreaseByAlimonyPayments"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Werbekosten') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByAdvertisingCosts"
                        field="parentIncome1.incomeDecreaseByAdvertisingCosts"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByAdvertisingCosts"
                        field="parentIncome2.incomeDecreaseByAdvertisingCosts"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Lohnsteuer') }}
                    </td>

                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByIncomeTax"
                        field="parentIncome1.incomeDecreaseByIncomeTax"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByIncomeTax"
                        field="parentIncome2.incomeDecreaseByIncomeTax"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Solidaritätszuschlag') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseBySolidaritySurcharge"
                        field="parentIncome1.incomeDecreaseBySolidaritySurcharge"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseBySolidaritySurcharge"
                        field="parentIncome2.incomeDecreaseBySolidaritySurcharge"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Kirchensteuer') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByChurchTax"
                        field="parentIncome1.incomeDecreaseByChurchTax"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByChurchTax"
                        field="parentIncome2.incomeDecreaseByChurchTax"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Arbeitnehmeranteil Rentenversicherung') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionPensionInsurance"
                        field="parentIncome1.incomeDecreaseByEmployeeContributionPensionInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionPensionInsurance"
                        field="parentIncome2.incomeDecreaseByEmployeeContributionPensionInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Arbeitnehmeranteil Krankenversicherung') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionHealthInsurance"
                        field="parentIncome1.incomeDecreaseByEmployeeContributionHealthInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionHealthInsurance"
                        field="parentIncome2.incomeDecreaseByEmployeeContributionHealthInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Arbeitnehmeranteil Pflegeversicherung') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionNursingCareInsurance"
                        field="parentIncome1.incomeDecreaseByEmployeeContributionNursingCareInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionNursingCareInsurance"
                        field="parentIncome2.incomeDecreaseByEmployeeContributionNursingCareInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Arbeitnehmeranteil Arbeitslosenversicherung') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByEmployeeContributionUnemploymentInsurance"
                        field="parentIncome1.incomeDecreaseByEmployeeContributionUnemploymentInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByEmployeeContributionUnemploymentInsurance"
                        field="parentIncome2.incomeDecreaseByEmployeeContributionUnemploymentInsurance"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        {{ $t('Abzug Sonstige') }}
                    </td>
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome1.incomeDecreaseByOther"
                        field="parentIncome1.incomeDecreaseByOther"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                    <kgr-child-parent-income-table-cell
                        v-model="childParentIncome.parentIncome2.incomeDecreaseByOther"
                        field="parentIncome2.incomeDecreaseByOther"
                        :error="error"
                        @error="$emit('error', $event)"
                    />
                </tr>
            </tbody>
            <tfoot>
                <tr class="kgr-table__row sum">
                    <td class="kgr-table__cell alignRight">
                        {{ $t('Gesamteinkommen je Elternteil') }}
                    </td>
                    <td class="kgr-table__cell">
                        <kgr-money :value="childParentIncome.parentIncome1.sum()" />
                    </td>
                    <td class="kgr-table__cell">
                        <kgr-money :value="childParentIncome.parentIncome2.sum()" />
                    </td>
                </tr>
                <tr class="kgr-table__row sum">
                    <td class="kgr-table__cell alignRight">
                        {{ $t('Gesamteinkommen') }}
                    </td>
                    <td class="kgr-table__cell">
                        <kgr-money :value="childParentIncome.sum()" />
                    </td>
                    <td class="kgr-table__cell"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import ChildParentIncome from '../../../js/dto/ChildParentIncome';
import ChildParentIncomeCreateTableCell from './ChildParentIncomeCreateTableCell';
import ChildParentIncomeHighestRate from './ChildParentIncomeHighestRate';
import DatePicker from '../../common/form/picker/DatePicker';
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';
import KgrMoney from '../../common/convert/Money';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-money': KgrMoney,
        'kgr-child-parent-income-table-cell': ChildParentIncomeCreateTableCell,
        'kgr-child-parent-income-highest-rate': ChildParentIncomeHighestRate,
    },
    props: {
        childParentIncome: {
            type: ChildParentIncome,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            isExpanded: true,
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    tfoot {
        border-top: 2px solid #a1a1a1;
    }
    .sum {
        font-weight: var(--kgr-font-weight-bold);
    }
    .alignRight {
        padding-right: 10px;
        text-align: right;
    }
</style>
